const Tag = ({ children }) => (
  <span className="bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300 text-xs font-medium px-3 py-1 rounded-full">
    {children}
  </span>
);

export default Tag;
